const header = document.querySelector(".wp-block-steam-blocks-header");

let last = window.scrollY;

document.documentElement.style.setProperty("--nav-offset", "0px");

/**
 * todo: scroll event is fired when the popper blocks global scrollbar, this causes the nav to jump.
 */
window.addEventListener("load", () => {
	last = window.scrollY;

	window.addEventListener("scroll", () => {
		if (!header) return;

		if (window.scrollY > last && window.scrollY > 62) {
			document.documentElement.style.setProperty("--nav-offset", "-62px");
		} else {
			document.documentElement.style.setProperty("--nav-offset", "0px");
		}

		last = window.scrollY;
	});
});
